<template lang="pug">
div
  v-card.pa-6.mt-4.round-xl(outlined)
    google-business-page-setup(:cols="6" :gmbAccountName="gmbAccountName" hasConnected showDescription @reconnect="$emit('googlePageSetup')")
  v-card.pa-6.mt-4.round-xl(outlined)
    review-page-setup
  v-card.pa-6.mt-4.round-xl(outlined)
    email-setup
  v-card.pa-6.mt-4.round-xl(outlined)
    sms-whatsapp-template-setup(:os="os")
</template>

<script>
import { mapGetters } from 'vuex'
import ReviewPageSetup from '@/components/review/settings/ReviewPageSetup.vue'
import EmailSetup from '@/components/review/settings/EmailSetup.vue'
import SmsWhatsappTemplateSetup from '@/components/review/settings/SmsWhatsappTemplateSetup.vue'
import GoogleBusinessPageSetup from '@/components/review/settings/GoogleBusinessPageSetup.vue'

export default {
  components: {
    ReviewPageSetup,
    EmailSetup,
    SmsWhatsappTemplateSetup,
    GoogleBusinessPageSetup
  },
  props: {
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  computed: {
    ...mapGetters({
      reviewAccount: 'review/getMainAccount',
    }),
    gmbAccountName() {
      return this.reviewAccount.account_name
    },
  }
}
</script>

<style scoped>
</style>